import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingOrderedList: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 0L0 2h1.5v2H4V0zm14 0H6v4h10zm0 6H6v4h10zM6 12h10v4H6zm-2 0v4H0v-1.5h1.5v-1H0V12zM0 8a2 2 0 1 1 4 0v2H0l2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingOrderedList
